// i18n: английский словарь. Ключ — русская строка ровно как в коде,
// index.html или server/assets/levels/*/story.json; {имя} — подстановка.
// Названия сюжета — как в английском трейлере (tools/trailer/titles_en.json):
// «The Spellbook», «Alone in a dark mansion», «Steal her spellbook»,
// «…and a hag with an axe».
//
// Поменяли русский текст — поменяйте и ключ здесь, иначе по-английски
// покажется русский. Проверка: node test/i18n_coverage.mjs (из client/).

export const EN: Record<string, string> = {
  // ── Меню (index.html) ──────────────────────────────────────────────────
  "Вернуться в игру": "Resume game",
  "Вход в игру": "Sign in",
  "Войти через Яндекс": "Sign in with Yandex",
  "Войти через Google": "Sign in with Google",
  "или": "or",
  "Ссылка на email": "Email me a link",
  "Профиль": "Profile",
  "Поменять ник": "Change nickname",
  "Выйти": "Sign out",
  "Выбор ника": "Choose a nickname",
  "Ваш игровой ник": "Your in-game nickname",
  "Публично отображается в чате и в истории матчей. Email не показывается другим игрокам.":
    "Shown publicly in chat and match history. Your email is never shown to other players.",
  "Ник (3–16, латиница/цифры/_-.)": "Nickname (3–16, Latin letters/digits/_-.)",
  "Отмена": "Cancel",
  "Сохранить": "Save",
  "арена с NPC": "arena with NPCs",
  "игра с другими игроками": "play against other people",
  "РЕЙТИНГ": "LEADERBOARD",
  "топ игроков": "top players",
  "КОМАНДА": "TEAM",
  "клан и приглашения": "clan and invites",
  "ПРОФИЛЬ": "PROFILE",
  "моя статистика": "my stats",
  "НАСТРОЙКИ": "SETTINGS",
  "звук и графика": "sound and graphics",
  "ЗАСТАВКА": "INTRO",
  "смотреть снова": "watch again",
  "Настройки звука и графики": "Sound and graphics settings",
  "Настройки": "Settings",
  "Громкость, яркость и постобработка сохраняются в этом браузере.":
    "Volume, brightness and post-processing are saved in this browser.",
  "Звуки:": "Sound:",
  "Музыка:": "Music:",
  "Яркость:": "Brightness:",
  "Постобработка (зерно, виньетка, сглаживание; вспышка света при выстреле)":
    "Post-processing (grain, vignette, anti-aliasing; muzzle light flash)",
  "Свечение ярких источников (bloom; только при включённой постобработке)":
    "Glow of bright lights (bloom; only with post-processing on)",
  "Назад": "Back",
  "Настройки Single Player": "Single Player settings",
  "Сцена": "Scene",
  "Кол-во NPC:": "NPCs:",
  "Начать": "Start",
  "СЮЖЕТ: КНИГА ЗАКЛИНАНИЙ": "STORY: THE SPELLBOOK",
  "Проберитесь в особняк, найдите книгу заклинаний, которую охраняет старуха.":
    "Sneak into the dark mansion and steal the spellbook guarded by a hag with an axe.",
  "Все против всех. Подсчёт фрагов и попаданий.": "Free-for-all. Frags and hits are counted.",
  "Создать комнату": "Create room",
  "Подключиться к публичной": "Join a public room",
  "Режим": "Mode",
  "Каждый за себя (FFA)": "Free-for-all (FFA)",
  "Команда на команду (TDM)": "Team vs team (TDM)",
  "Время раунда": "Round time",
  "3 минуты": "3 minutes",
  "5 минут": "5 minutes",
  "10 минут (стандарт)": "10 minutes (standard)",
  "15 минут": "15 minutes",
  "Раундов": "Rounds",
  "3 (стандарт)": "3 (standard)",
  "Макс. игроков:": "Max players:",
  "Приватная (доступ по ссылке)": "Private (link only)",
  "Создать": "Create",
  "Публичные комнаты": "Public rooms",
  "Обновить": "Refresh",
  "Ссылка на комнату": "Room link",
  "Комната создана": "Room created",
  "Отправьте ссылку друзьям.": "Send the link to your friends.",
  "Копировать": "Copy",
  "Скопировано": "Copied",
  "Войти в комнату": "Enter room",
  "Подключиться к приватной комнате": "Join a private room",
  "Приглашение в комнату": "Room invitation",
  "Загружаем информацию…": "Loading info…",
  "Подключиться": "Join",
  "Профиль игрока": "Player profile",
  "Рейтинг игроков": "Leaderboard",
  "Команда": "Team",
  "Соберите свою команду: создайте её и приглашайте игроков по нику.":
    "Build your own team: create it and invite players by nickname.",
  "Название (3-24)": "Name (3-24)",
  "Ночные Волки": "Night Wolves",
  "Тег (2-5, латиница/цифры)": "Tag (2-5, Latin letters/digits)",
  "Создать команду": "Create team",
  "Вас пригласили:": "You've been invited:",
  "Пригласить игрока (ник)": "Invite a player (nickname)",
  "Позвать": "Invite",
  "Покинуть команду": "Leave team",
  "В меню": "Main menu",
  "WASD — движение, мышь — обзор, ЛКМ — стрельба, Esc — пауза, R — рестарт, Ctrl+L — debug HUD (fps)":
    "WASD — move, mouse — look, LMB — shoot, Esc — pause, R — restart, Ctrl+L — debug HUD (fps)",
  "Конфиденциальность": "Privacy",
  "Удаление аккаунта": "Delete account",

  // ── HUD матча и тач-управление (index.html) ────────────────────────────
  "Матч окончен": "Match over",
  "Игрок": "Player",
  "Раунды": "Rounds",
  "Фраги": "Frags",
  "Смерти": "Deaths",
  "Комната закроется автоматически…": "The room will close automatically…",
  "Убит": "Dead",
  "Меню и пауза": "Menu and pause",
  "Обзор (тащить пальцем)": "Look (drag with finger)",
  "Джойстик движения (тащить пальцем)": "Movement joystick (drag with finger)",
  "Присесть": "Crouch",
  "Прыжок": "Jump",
  "Действие (как E)": "Use (like E)",
  "Огонь": "Fire",

  // ── Вход, ник, комнаты (main.ts) ───────────────────────────────────────
  "Хотите на весь экран? «Поделиться» → «На экран «Домой»» — оттуда игра запускается без панелей браузера.":
    "Want it full screen? Share → “Add to Home Screen” — from there the game starts without browser bars.",
  "Закрыть подсказку": "Close tip",
  "Не удалось загрузить модель солдата (/models/soldier.glb). Проверьте сеть и обновите страницу.":
    "Couldn't load the soldier model (/models/soldier.glb). Check your connection and reload the page.",
  "Не удалось подключиться к серверу. Убедитесь, что сервер запущен, и попробуйте снова.":
    "Couldn't connect to the server. Make sure it is running and try again.",
  "Сервер не прислал ID игрока (таймаут). Попробуйте снова или обновите страницу.":
    "The server didn't send a player ID (timeout). Try again or reload the page.",
  "Соединение с сервером разорвано до готовности. Попробуйте снова.":
    "The connection to the server dropped before the game was ready. Try again.",
  "Синхронизация с сервером…": "Syncing with the server…",
  "Игрок #{id}": "Player #{id}",
  "Гостевой режим. Войдите, чтобы сохранить ник и играть в DM.":
    "Guest mode. Sign in to keep your nickname and play Deathmatch.",
  "Войдите, чтобы начать игру.": "Sign in to start playing.",
  " игрока {nick}": " hosted by {nick}",
  "Ссылка на комнату устарела: комната уже закрыта. Войдите — и создайте свою или найдите комнату в списке публичных.":
    "This room link has expired: the room is already closed. Sign in to create your own or find one in the public list.",
  "Вас пригласили в Deathmatch-комнату{details}. ": "You've been invited to a Deathmatch room{details}. ",
  "Войдите или создайте аккаунт, чтобы присоединиться.": "Sign in or create an account to join.",
  "Введите e-mail": "Enter your email",
  "Ссылка отправлена. Проверьте почту (ссылка действует 24ч).":
    "Link sent. Check your inbox (the link is valid for 24h).",
  "Не удалось отправить письмо ({status}): {text}": "Couldn't send the email ({status}): {text}",
  "3..16 символов, латиница / цифры / _-.": "3..16 characters: Latin letters / digits / _-.",
  "Проверяем…": "Checking…",
  "Ошибка проверки": "Check failed",
  "Свободен": "Available",
  "Ошибка сети": "Network error",
  "Ошибка сети.": "Network error.",
  "Ошибка": "Error",
  "Создаём…": "Creating…",
  "Приватная комната создана": "Private room created",
  "Отправьте ссылку друзьям. Попасть в комнату можно только по ней.":
    "Send the link to your friends. The room can only be joined through it.",
  "Публичная комната создана": "Public room created",
  "Отправьте ссылку друзьям — или они найдут комнату в списке публичных. Если у друга нет аккаунта, ссылка сначала предложит войти.":
    "Send the link to your friends, or they can find the room in the public list. If a friend has no account, the link will ask them to sign in first.",
  "Публичных комнат с местами пока нет.": "No public rooms with free slots yet.",
  "{n} комнат(ы)": "{n} room(s)",
  "Комната {name}": "Room {name}",
  "{m}мин": "{m} min",
  "Войти": "Join",
  "Загружаем информацию о комнате…": "Loading room info…",
  "Не удалось найти комнату по этой ссылке.": "Couldn't find a room for this link.",
  "Сцена: {scene}, игроков: {n}/{max}": "Scene: {scene}, players: {n}/{max}",
  ", хост: {nick}": ", host: {nick}",
  "Ошибка сети при загрузке комнаты.": "Network error while loading the room.",
  "Загружаем…": "Loading…",
  "На мобильном отключено для скорости": "Disabled on mobile for speed",
  "Открыть дверь": "Open door",
  "[E] Открыть дверь": "[E] Open door",

  // ── Профиль, рейтинг, команда (main.ts) ────────────────────────────────
  "Не удалось загрузить профиль ({status}).": "Couldn't load the profile ({status}).",
  "Команда:": "Team:",
  "Рейтинг:": "Rating:",
  "Побед:": "Wins:",
  "Матчей:": "Matches:",
  "Фраги:": "Frags:",
  "Смерти:": "Deaths:",
  "Попаданий:": "Hits:",
  "Матчей пока нет.": "No matches yet.",
  "Последние матчи:": "Recent matches:",
  "Не удалось загрузить рейтинг ({status}).": "Couldn't load the leaderboard ({status}).",
  "Пока пусто — сыграйте матч в Deathmatch, и рейтинг появится.":
    "Nothing here yet — play a Deathmatch game and the leaderboard will appear.",
  "Рейтинг": "Rating",
  "Победы": "Wins",
  "Матчи": "Matches",
  "Не удалось загрузить команду ({status}).": "Couldn't load the team ({status}).",
  "участников: {n} из 16": "members: {n} of 16",
  "Распустить команду": "Disband team",
  "★ владелец": "★ owner",
  "Кик": "Kick",
  "{nick} исключён": "{nick} was kicked",
  "зовёт {nick}": "invited by {nick}",
  "Принять": "Accept",
  "Вы в команде!": "You're in the team!",
  "Отклонить": "Decline",
  "Название: 3-24 символа.": "Name: 3-24 characters.",
  "Тег: 2-5 символов, латиница/цифры.": "Tag: 2-5 characters, Latin letters/digits.",
  "Команда создана!": "Team created!",
  "Введите ник игрока.": "Enter a player's nickname.",
  "Приглашение отправлено: {nick}": "Invite sent: {nick}",
  "Точно покинуть команду?": "Really leave the team?",
  "Вы вышли из команды.": "You left the team.",

  // ── Матч (main.ts) ─────────────────────────────────────────────────────
  "КРАСНЫЕ": "RED",
  "СИНИЕ": "BLUE",
  "БЕЗ КОМАНДЫ": "NO TEAM",
  " (вы)": " (you)",
  "РАУНД {n}": "ROUND {n}",
  "из {total}": "of {total}",
  "Ничья в раунде": "Round draw",
  "Раунд за {who}": "Round goes to {who}",
  " — ваша команда!": " — your team!",
  "Раунд за вами!": "You win the round!",
  "Переход в {scene}…": "Moving to {scene}…",
  "Комната закрыта.": "Room closed.",
  "Хост покинул комнату.": "The host left the room.",
  "Комната опустела.": "The room is empty.",
  "Сервер завершил комнату.": "The server closed the room.",
  "Матч завершён.": "Match finished.",
  "ожидание игроков": "waiting for players",
  "матч окончен": "match over",
  "Раунд {n}/{total}": "Round {n}/{total}",
  "раунды {a}:{b}": "rounds {a}:{b}",
  "Ожидание игроков…": "Waiting for players…",
  "матч начнётся, когда зайдёт соперник": "the match starts when an opponent joins",
  "Бой через {n}…": "Fight in {n}…",
  "вы за {team}": "you're on {team}",
  "Ничья": "Draw",
  "Победили": "Winners:",
  " — победа!": " — you win!",
  "Победа!": "Victory!",
  "Победил": "Winner:",
  "(low fps → грубее интерполяция; macOS энергосбережение≈30Hz; F7 разрешение ниже)":
    "(low fps → coarser interpolation; macOS power saving≈30Hz; F7 lowers resolution)",
  "скрыть": "hide",

  // ── Сюжет «Книга заклинаний» ───────────────────────────────────────────
  "Книга заклинаний": "The Spellbook",
  "КНИГА ЗАКЛИНАНИЙ": "THE SPELLBOOK",
  "книга заклинаний": "the spellbook",
  "Книга заклинаний: забег окончен.": "The Spellbook: run over.",
  "Книга ваша": "The spellbook is yours",
  "Этап сначала": "Stage restarted",
  "СТАРУХА": "THE HAG",
  "ЭТАП {n}/{total}": "STAGE {n}/{total}",
  "{n} м": "{n} m",
  "убито {n}": "killed {n}",
  "развеяно призраков {n}": "ghosts dispelled {n}",
  "«{text}»": "“{text}”",
  "Старуха мертва, книга у вас. Мертвецы сада легли обратно в землю, души дома свободны.":
    "The hag is dead and the book is yours. The garden's dead are back in their graves, and the souls of the house are free.",
  "Время": "Time",
  "Убито нечисти": "Undead slain",
  "Развеяно призраков": "Ghosts dispelled",
  "Смертей": "Deaths",
  "Ещё раз": "Play again",
  // Этапы: заголовок и подсказка (STAGE_TEXT и story.json; у этапа 3 на
  // сервере подсказка длиннее — обе строки).
  "Проберитесь в особняк": "Get into the mansion",
  "Через сад к дому на холме. Двери — клавиша E": "Through the garden to the house on the hill. Doors: press E",
  "Найдите книгу заклинаний": "Find the spellbook",
  "Картины шепчут тому, кто на них смотрит": "The paintings whisper to whoever looks at them",
  "Победите старуху": "Defeat the hag",
  "Она медленная, но топор бьёт насмерть": "She is slow, but her axe kills",
  "Она медленная, но топор бьёт насмерть. Не подпускайте": "She is slow, but her axe kills. Keep your distance",
  "Возьмите книгу": "Take the spellbook",
  "Книга парит в дальнем конце чердака": "The book floats at the far end of the attic",
  // Шёпоты и победа (server/assets/levels/alone_in_the_dark/story.json).
  "Книга заклинаний ваша. Мертвецы падают замертво, души дома свободны.":
    "The spellbook is yours. The dead fall still, and the souls of the house are free.",
  "Старуха с холма держит книгу заклинаний. Ею она подняла мертвецов из сада.":
    "The hag on the hill keeps a spellbook. With it she raised the dead from the garden.",
  "Дверь за спиной захлопнулась. В доме кто-то плачет.":
    "The door slammed shut behind you. Someone is crying in the house.",
  "Наверху скрипят половицы. Она ждёт.": "Floorboards creak upstairs. She is waiting.",
  "Старуха рассыпалась прахом. Книга выскользнула из её рук.":
    "The hag crumbled to dust. The book slipped from her hands.",
  "Кто топчет мой чердак?.. Книга моя!": "Who's stomping around my attic?.. The book is mine!",
  "Тише... она слышит шаги. Книга не там, где полки, — она под самой крышей.":
    "Quiet... she can hear footsteps. The book isn't on the shelves — it's right under the roof.",
  "Наверх, по западной лестнице. Слышишь? Она точит топор.":
    "Up the west staircase. Hear that? She's sharpening her axe.",
  "Сотни книг — и ни одной нужной. Старуха унесла свою на чердак.":
    "Hundreds of books, and not the one you need. The hag took hers up to the attic.",
  "Дверь не заперта. Нажмите E.": "The door is unlocked. Press E.",
  "Здесь её нет. Следы топора на паркете ведут наверх.":
    "It's not here. Axe marks on the parquet lead upstairs.",

  // ── Заставка ───────────────────────────────────────────────────────────
  "представляет": "presents",
  "КОСНИТЕСЬ, ЧТОБЫ НАЧАТЬ": "TAP TO START",
  "НАЖМИТЕ, ЧТОБЫ НАЧАТЬ": "CLICK TO START",
  "включите звук": "sound on",
  "загрузка…": "loading…",
  "коснитесь — пропустить": "tap to skip",
  "любая клавиша — пропустить": "any key to skip",

  // ── Оружие ─────────────────────────────────────────────────────────────
  "Кулаки": "Fists",
  "Бензопила": "Chainsaw",
  "Дробовик": "Shotgun",
  "Автомат": "Rifle",
  "Снайперка": "Sniper",
  "Огнемёт": "Flamethrower",
  "Лазер": "Laser",
  "Ракетница": "Rocket launcher",
  "Граната": "Grenade",
  "Сменить оружие": "Switch weapon",
  "Оптический прицел": "Scope",
  "◎ — оптический прицел": "◎ — scope",
  "ПКМ или Z — оптический прицел, колесо — кратность": "RMB or Z — scope, wheel — zoom",

  // ── Артефакты ──────────────────────────────────────────────────────────
  "Ящик патронов": "Ammo crate",
  "Саквояж врача": "Doctor's bag",
  "Рубиновый медальон": "Ruby medallion",
  "Череп-амулет": "Skull amulet",
  "Лунный кристалл": "Moon crystal",
  "+{n} серебра": "+{n} silver",
  "+{n} патронов": "+{n} ammo",
  "Здоровье восполнено": "Health restored",
  "находка в обломках": "found in the rubble",
  "предел реликвий за матч": "relic limit for this match",

  // ── Персонажи ──────────────────────────────────────────────────────────
  "Здоровье": "Health",
  "Скорость": "Speed",
  "Броня": "Armor",
  "Солдат": "Soldier",
  "Штурмовик спецотряда": "Special forces trooper",
  "Каска и бронежилет. Держит удар лучше остальных.": "Helmet and body armor. Takes a hit better than anyone.",
  "Сыщица": "Investigator",
  "Исследовательница оккультного": "Occult investigator",
  "Лёгкая кожанка и сапоги на шнуровке — первой добегает до укрытия.":
    "Light leather jacket and lace-up boots — always first to reach cover.",
  "Охотник": "Hunter",
  "Охотник на нечисть": "Monster hunter",
  "Маска-череп, серебряные колья на перевязи. Живучий: выдерживает лишнее попадание.":
    "Skull mask, silver stakes on a bandolier. Tough: survives one extra hit.",
  "Выбор персонажа": "Choose a character",
  "Персонаж": "Character",
  "ПЕРСОНАЖ:": "CHARACTER:",
  "Предыдущий персонаж": "Previous character",
  "Следующий персонаж": "Next character",
  "Потяните, чтобы повернуть": "Drag to rotate",
  "Серебро:": "Silver:",
  "Готово →": "Done →",
  "серебро {n} · апгрейды": "silver {n} · upgrades",
  "выбор и апгрейды": "choose and upgrade",
  "база": "base",
  "−{pct} % урона": "−{pct}% damage",
  "макс.": "max",
  "Сильная сторона персонажа: +1 уровень бесплатно": "Character's strength: +1 level for free",
  "Гостю — до {cap} уровня": "Guests: up to level {cap}",
  "Уровень {next}: {price} серебра": "Level {next}: {price} silver",
  "фраг {kill} · бот {bot} · раунд {round} · матч {match}": "frag {kill} · bot {bot} · round {round} · match {match}",
  " · реликвии до {cap}": " · relics up to {cap}",
  "Новый персонаж и уровни — со следующего входа в матч.": "The new character and levels apply from your next match.",
  "Гость: прогресс хранится в этом браузере, уровни до {guestMax}. Войдите, чтобы сохранять серебро и качать до {max}.":
    "Guest: progress is stored in this browser, levels up to {guestMax}. Sign in to keep your silver and level up to {max}.",
  "Уровни общие для всех персонажей. Сильная сторона персонажа — золотом.":
    "Levels are shared by all characters. A character's strength is shown in gold.",
  "Гостю доступно до {cap} уровня — войдите, чтобы качать дальше":
    "Guests can level up to {cap} — sign in to keep upgrading",
  "Гостю доступно до {cap} уровня — войдите, чтобы качать дальше.":
    "Guests can level up to {cap} — sign in to keep upgrading.",
  "{stat}: уровень {n}.": "{stat}: level {n}.",
  "Уровень уже максимальный": "Already at max level",
  "Нужно {price} серебра": "You need {price} silver",
  "Ошибка {status}": "Error {status}",
  "Ошибка ответа сервера": "Bad server response",
  "Нет связи с сервером": "No connection to the server",

  // ── Ошибки, которые присылает сервер (http.Error, reason) ──────────────
  "уже занят": "already taken",
  "ник не может быть пустым": "the nickname can't be empty",
  "3..16 символов, латиница/цифры/_-.": "3..16 characters: Latin letters/digits/_-.",
  "этот ник зарезервирован": "this nickname is reserved",
  "не найдено": "not found",
  "вы не состоите в команде": "you're not in a team",
  "игрок уже состоит в команде": "the player is already in a team",
  "только владелец команды может это сделать": "only the team owner can do that",
  "название команды уже занято": "this team name is already taken",
  "тег команды уже занят": "this team tag is already taken",
  "команда заполнена": "the team is full",
  "приглашение уже отправлено": "the invite has already been sent",
  "название: 3-24 символа; тег: 2-5 (латиница/цифры)": "name: 3-24 characters; tag: 2-5 (Latin letters/digits)",
  "игрок с таким ником не найден": "no player with this nickname",
  "не хватает серебра": "not enough silver",
  "уровень уже максимальный": "already at max level",
};
